/*aixos封装处理*/
import axios from "axios";
// import router from '../../router.js'
import qs from "qs";
import Vue from "vue";
import { Loading, Message } from "element-ui";
import router from "../router";

// const baseURL = 'http://114.67.239.56:40013/jd-point-web';
const baseURL = "";
const env = process.env.NODE_ENV;

const $axios = axios.create({
  baseURL: "/jd-point-web",
});
Vue.prototype.$http = $axios;
var loadingInstance;

// $axios.defaults.withCredentials = false;
$axios.defaults.withCredentials = true;
$axios.interceptors.request.use(
  function (config) {
    if (process.env.NODE_ENV == "production") {
      config.url = baseURL + config.url;
    }
    // 显示loading
    // loadingInstance = Loading.service({
    //   lock: true,
    //   text: '加载中',
    //   spinner: 'el-icon-loading',
    //   background: 'rgba(0, 0, 0, 0.7)'
    // });
    // console.log(config);
    let hdToken = sessionStorage.getItem("hdToken");
    if(hdToken){
      config.headers['YUNQUE-TOKEN'] = hdToken;
    }
    return config;
  },
  function (err) {
    // console.log(err);
    errorState(err);
  }
);

// 添加响应拦截器(对接口响应返回数据做点什么)----------------------------------------------------------------
$axios.interceptors.response.use(
  function (res) {
    // loadingInstance.close();
    // console.log(res);
    if (res.status === 200) {
      // 响应拦截器
      if (!res.data.code) {
        return Promise.resolve(res);
      }
      if (
        res.data.code == "200" ||
        res.data.code == "501" ||
        res.data.code == "1"
      ) {
        if (res.config.method == "post") {
          return Promise.resolve(res);
        } else {
          return Promise.resolve(res.data);
        }
      } else if (res.data.code === -1) {
        // window.open('https://yz.yqcrm.cn/login','_self');
        Vue.prototype.jumpLoginPage(res.data.message);
      } else if (res.data.code == 10001) {
        Vue.prototype.jumpLoginPage2(res.data.message);
      } else {
        if (res.data.message) {
          Message.error(res.data.message);
        } else {
          Message.error(res.message);
        }
        // return Promise.reject(false);
      }
    } else {
      Message.error(res.statusText);
    }
  },
  function (err) {
    // console.log(err);
    errorState(err);
  }
);

// 错误的统一处理---------------------------------------------------------------------------
function errorState(err) {
  // loadingInstance.close();
  if (String(err).indexOf("600") != -1) {
    // location.href = "https://fuwu.taobao.com/ser/my_service.htm"
    location.href =
      "https://oauth.taobao.com/authorize?response_type=code&client_id=12666072&redirect_uri=http%3A%2F%2Fdxe.yusms.com%2Ftblogin.do&state=leaseId%3A0%3BitemCode%3Ats-131195-1%3Bscope%3Ar1%2Cr2%2Cw1%2Cw2%3BversionNo%3A2%3Bsign%3AE312C246EF847BC54552CB5D84AAB41B%3Bouter_trade_code%3A%3Btimestamp%3A1551771643881&from_site=fuwu";
  } else {
    var e = (err + "").indexOf("timeout") > -1 ? "请求超时" : err + "";
    Message.error(e);
    return err;
  }
}

// 封装数据返回成功提示函数(对后台返回状态码进行处理)---------------------------------------------------------------------------
// function successState(res) {
// 	//console.log(JSON.stringify(res))
// 	loadingInstance.close();
// 	if(Number(res.code) === 200) {
// 		return res;
// 	}else{
// 		Message.error(res.message);
// 	}
// 	// if(Number(res.code) === 9001) {
// 	// 	return res;
// 	// }else if(Number(res.code) === 500) {//7001登录失败 1003会话失效
// 	// 	Message.error('请重新登录！');
// 	// 	// router.push('/login');
// 	// }else{
// 	// 	Message.error(res.message);
// 	// }
// }

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    $axios
      .get(url, {
        params: params,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getType1(url, params) {
  return new Promise((resolve, reject) => {
    $axios
      .get(url + params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  $axios.defaults.headers.post["Content-Type"] =
    "application/x-www-form-urlencoded;charset=UTF-8";
  console.log(qs.stringify(params));
  return new Promise((resolve, reject) => {
    $axios
      .post(url, qs.stringify(params))
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function postLogin(url, params) {
  $axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=UTF-8";
  return new Promise((resolve, reject) => {
    $axios
      .post(
        // http://192.168.1.235:8000/jd-yusms/login/testLogin
        "/login/testLogin",
        null,
        { params }
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function imagePost(url, params) {
  $axios.defaults.headers.post["Content-Type"] =
    "multipart/form-data;charset=UTF-8";
  return new Promise((resolve, reject) => {
    $axios
      .post(url, params, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
/**
 * postJson方法，对应post请求
 * body请求体
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postJson(url, params) {
  $axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=UTF-8";
  return new Promise((resolve, reject) => {
    $axios
      .post(url, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function deleteApi(url, params) {
  return new Promise((resolve, reject) => {
    $axios
      .delete(url, { params: params })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 */
export function put(url, params) {
  // $axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
  $axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=UTF-8";
  return new Promise((resolve, reject) => {
    // $axios.put(url, qs.stringify(params))
    $axios
      .put(url, params)
      .then((res) => {
        resolve(res.data || res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function postUrl(url, params) {
  $axios.defaults.headers.post["Content-Type"] =
    "application/json;charset=UTF-8";
  return new Promise((resolve, reject) => {
    $axios
      .post(url, null, { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

// 封装axios--------------------------------------------------------------------------------------
// function apiAxios(method, url, params) {
// 	console.log(params)
// 	// let sid = localStorage.getItem('sid');
// 	// //isTrue = url.indexOf('ogin')>-1?true:false;//不要SessionID的接口
// 	// let noSessionApi = ['ogin','uploadfile'];
// 	// let isTrue = noSessionApi.some((item)=>{
// 	// 	return url.indexOf(item) > -1
// 	// })
// 	// params = params || {};
// 	// if(sid && !isTrue){
// 	// 	params.SessionID = sid;
// 	// }
//     let httpDefault = {
// 		method: method,
// 		//baseURL: baseURL,
// 		url: url,
// 		params: method === 'GET' || method === 'DELETE' ? params : null,
// 		data: method === 'POST' || method === 'PUT' ? qs.stringify(params) : null,
// 		timeout: 100000
// 	}
//
// 	return new Promise((resolve, reject) => {
// 		$axios(httpDefault)
// 		.then((res) => {
// 			successState(res);//状态码处理
// 			Number(res.code) === 9001 && resolve(res);
// 		}).catch((err) => {
// 			errorState(err);
// 			reject(err)
// 		})
// 	})
// }

// 输出函数getAxios、postAxios、putAxios、delectAxios，供其他文件调用-----------------------------
// Vue.js的插件应当有一个公开方法 install。这个方法的第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象。
// export default {
// 	install: function(Vue) {
// 		Vue.prototype.getAxios = (url, params) => apiAxios('GET', url, params)
// 		Vue.prototype.postAxios = (url, params) => apiAxios('POST', url, params)
// 		Vue.prototype.putAxios = (url, params) => apiAxios('PUT', url, params)
// 		Vue.prototype.delectAxios = (url, params) => apiAxios('DELECT', url, params)
// 	}
// }
